import React, { FunctionComponent } from "react";

import commonStyles from "../../CommonStyles/CommonGraphStyles.module.css";
import IntBarChartOrg from "../IntBarChartOrg/IntBarChartOrg";
import IntBarTable from "../IntBarTable/IntBarTable";
import { Pie } from "react-chartjs-2";

type props = {
  analyticsData: any;
  usersList: any;
  checked: boolean;
  teamsData: any;
  history: any;
  filter: "MTD" | "YTD" | "PM" | "All" | "CUSTOM";
  source: boolean;
  taskFilter: any;
  leadFilter: any;
};

const InterestedPropertyStage: FunctionComponent<props> = ({
  analyticsData,
  usersList,
  checked,
  history,
  teamsData,
  filter,
  source,
  taskFilter,
  leadFilter,
}) => {
  return (
    <>
      <div id="propertyStage" className={commonStyles.graphContainer}>
        <IntBarChartOrg
          analyticsData={analyticsData}
          heading={"Interested Property Stage"}
          type={"propertyStage"}
          color={["#1F639C", "#3CAEA2"]}
          GraphType={Pie}
          style={{ width: "40%" }}
          history={history}
          filter={filter}
        />
        <div className={commonStyles.line}></div>
        <IntBarTable
          type={"propertyStage"}
          data={analyticsData}
          heading={"Interested Property Stage Summary"}
          usersList={usersList}
          checked={checked}
          teamsData={teamsData}
          style={{ width: "60%" }}
          filter={filter}
          history={history}
          source={source}
          taskFilter={taskFilter}
          leadFilter={leadFilter}
        />
      </div>
    </>
  );
};

export default InterestedPropertyStage;
